<template>
  <b-container class="bv-example-row bv-example-row-flex-cols" fluid>
    <b-row align-v="center">
      <b-col cols="auto">
        <b-form-radio-group v-model="filterTypeComputed">
          <b-form-radio name="some-radios" value="all">ทั้งหมด</b-form-radio>
          <b-form-radio name="some-radios" value="direction">
            <b-form-select
              v-model="directionFilterSelectedComputed"
              value-field="id"
              text-field="direction"
              :options="directions"
              size="sm"
            >
              <template slot="first">
                <option :value="null">ทั้งหมด</option>
              </template>
            </b-form-select>
          </b-form-radio>
          <b-form-radio name="some-radios" value="corporation">
            <b-form-select
              v-model="corporationFilterSelectedData"
              text-field="name"
              value-field="index"
              :options="platformsComputed"
              size="sm"
            >
              <template slot="first">
                <option :value="null" disabled>-- เลือกบริษัท --</option>
              </template>
            </b-form-select>
          </b-form-radio>
        </b-form-radio-group>
      </b-col>
      <b-col cols="auto">
        <b-form-select
          v-model="statusFilterSelectedComputed"
          value-field="id"
          text-field="name"
          :options="paymentStatus"
          size="sm"
        >
          <template slot="first">
            <option :value="null" disabled>-- เลือกสถานะ --</option>
            <option value="all">เลือกทั้งหมด</option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="auto">
        <b-form-select
          v-model="creditTypeSelectedComputed"
          value-field="id"
          text-field="type_name"
          :options="creditType"
          size="sm"
        >
          <template slot="first">
            <option :value="null" disabled>-- เลือกเครดิต --</option>
            <option value="all">ทั้งหมด</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "InvoiceFilterComponent",
  props: {
    filterType: {
      required: true,
    },
    directionFilterSelected: {
      required: true,
    },
    corporationFilterSelected: {
      required: true,
    },
    statusFilterSelected: {
      required: true,
    },
    creditTypeSelected: {
      required: true,
    },
    platformsType: {
      type: String,
      default: "corporation",
    },
  },
  data() {
    return {
      corporationFilterSelectedData: null,
    };
  },
  mounted() {
    this.corporationFilterSelectedData = this.corporationFilterSelectedComputed;
  },
  computed: {
    ...mapGetters({
      corporations: "Corporation/getAll",
      platforms: "Account/getPlatforms",
      directions: "Direction/getAll",
      paymentStatus: "Account/getPaymentStatuses",
      creditType: "CreditType/getAll",
    }),
    creditTypeSelectedComputed: {
      get() {
        return this.creditTypeSelected;
      },
      set(val) {
        this.$emit("update:creditTypeSelected", val);
      },
    },
    filterTypeComputed: {
      get() {
        return this.filterType;
      },
      set(value) {
        this.$emit("update:filterType", value);
      },
    },
    corporationFilterSelectedComputed: {
      get() {
        return this.corporationFilterSelected;
      },
      set(value) {
        this.$emit("update:corporationFilterSelected", value);
      },
    },
    platformsComputed() {
      // return this.platforms.map((value, index) => ({
      //   ...value,
      //   index
      // }));

      return this.platforms
        .filter((value) => value.is_filter === 1)
        .map((value, index) => ({
          ...value,
          index,
        }));
    },
    platformsTypeComputed: {
      get() {
        return this.platformsType;
      },
      set(value) {
        this.$emit("update:platformsType", value);
      },
    },
    directionFilterSelectedComputed: {
      get() {
        return this.directionFilterSelected;
      },
      set(value) {
        this.$emit("update:directionFilterSelected", value);
      },
    },
    statusFilterSelectedComputed: {
      get() {
        return this.statusFilterSelected;
      },
      set(value) {
        this.$emit("update:statusFilterSelected", value);
      },
    },
  },
  watch: {
    corporationFilterSelectedComputed(value) {
      // let corporation = this.platformsComputed.find(
      //   platform => platform.index === value
      // );
      // this.platformsTypeComputed = corporation.platform_type;
      // console.log(corporation)
      // console.log(value)
      // console.log(this.platformsTypeComputed)
    },
    corporationFilterSelectedData(value) {
      // console.log(value);
      // this.corporationFilterSelectedComputed = this.platforms[value].id;
      let corporation = this.platformsComputed.find(
        (platform) => platform.index === value
      );
      this.platformsTypeComputed = corporation.platform_type;
      this.corporationFilterSelectedComputed = corporation.id;

      // console.log(this.corporationFilterSelectedComputed, 'id')
    },
  },
};
</script>

<style scoped>
</style>
